import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const KEY = 'ominia.theme';

const ThemeContext = createContext({
  scheme: 'light',
  toggle: () => {},
  setScheme: (_s) => {},
});

export function ThemeProvider({ children }) {
  const getInitial = () => {
    if (typeof window === 'undefined') return 'light';
    const s = window.localStorage.getItem(KEY);
    if (s === 'dark' || s === 'light') return s;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  const [scheme, setSchemeState] = useState(getInitial);

  useEffect(() => {
    const root = document.documentElement;
    if (scheme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    window.localStorage.setItem(KEY, scheme);
  }, [scheme]);

  const toggle = useCallback(() => setSchemeState((prev) => (prev === 'dark' ? 'light' : 'dark')), []);
  const setScheme = useCallback((next) => {
    setSchemeState(next === 'dark' ? 'dark' : 'light');
  }, []);

  const value = useMemo(() => ({ scheme, toggle, setScheme }), [scheme, toggle, setScheme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  return useContext(ThemeContext);
}
